export default __webpack_public_path__ + "static/media/ErrorFilledIcon.871fbe6b.svg";